<ag-grid-angular
  class="ag-theme-material h-full"
  [ngClass]="{ 'embedded-table': minified }"
  [rowData]="rowData"
  [initialState]="initialState"
  [rowSelection]="rowSelection"
  [cellSelection]="cellSelection"
  [selectionColumnDef]="selectionColumnDef"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  [modules]="modules"
  [sideBar]="sideBar"
  [components]="components"
  [statusBar]="statusBar"
  [getMainMenuItems]="getMainMenuItems"
  [loading]="isLoading"
  [loadingOverlayComponent]="loadingOverlayComponent"
  [noRowsOverlayComponent]="noRowsOverlayComponent"
  [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
  [rowGroupPanelShow]="rowGroupPanelShow"
  [rowHeight]="30"
  [valueCache]="true"
  [animateRows]="true"
  [suppressNoRowsOverlay]="rowData === undefined || isLoading"
  [suppressCsvExport]="true"
  [suppressExcelExport]="true"
  [suppressCellFocus]="true"
  (stateUpdated)="onGridStateUpdated($event)"
  [suppressMoveWhenColumnDragging]="true"
  (rowSelected)="onRowSelected($event)"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="onFirstDataRendered()"
  (stateUpdated)="onGridStateUpdated($event)"
>
</ag-grid-angular>
